export default [
  
    {
        subject: "contract",
        key: "submittedToHOD", //this is the parameter found in the url /form/:key 
        pageTitle: "Contracts Submitted to Procurement",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "HOD Pending Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
   
 
    
    ///DONE /////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


    //FOR Contract Manager [branch user]========================================================================
     
    {
        subject: "contract",
        key: "New Contracts", //this is the parameter found in the url /form/:key 
        pageTitle: "New Contracts",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "New Contracts",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: true,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "New Contracts",
            }
        },
    },

    
    {
        subject: "contract",
        key: "ProcRejectedContract", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected Contract",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Proc Rejected Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
    {
        subject: "contract",
        key: "ProcApprovedContract", //this is the parameter found in the url /form/:key 
        pageTitle: "Approved By Procurement",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
    {
        subject: "contract",
        key: "HODApprovedContract", //this is the parameter found in the url /form/:key 
        pageTitle: "Approved By Procurement",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "HOD Approved Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
    {
        subject: "contract",
        key: "HODRejectedContract", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected Contract",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "HOD Rejected Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },

    //------------------------------------------------------------------------------------------
  

    //FOR HOD Contract Approver========================================================================
    {
        subject: "contract",
        key: "HOD Pending Contract", //this is the parameter found in the url /form/:key 
        pageTitle: "HOD Pending Contract",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "HOD Pending Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
    {
        subject: "contract",
        key: "HOD Approved Contract", //this is the parameter found in the url /form/:key 
        pageTitle: "Approve Contract",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "HOD Approved Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
    {
        subject: "contract",
        key: "HOD Rejected Contract", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected Contract",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "HOD Rejected Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
    
    //------------------------------------------------------------------------------------------



     //FOR Contract Approver [PROCUREMENT TEAM]========================================================================

     {
        subject: "contract",
        key: "procPendingApproval", //this is the parameter found in the url /form/:key 
        pageTitle: "Contract Pending Approval",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "HOD Approved Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },
    {
        subject: "contract",
        key: "Proc Rejected Contract", //this is the parameter found in the url /form/:key 
        pageTitle: "Rejected Contract",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Proc Rejected Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },


    {
        subject: "contract",
        key: "Proc Approved Contracts", //this is the parameter found in the url /form/:key 
        pageTitle: "Contracts Approved By Procurement",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "contracts",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                status: "Approved Contract",
            },
            filterEndpoint: "getContractByStatus",
            showAddBtn: false,
            showActionButton: false, //if this is false the add and edit button will not be shown 
            showEditBtn: false,
            additionalData: {
                contractStatus: "",
            }
        },
    },

    //------------------------------------------------------------------------------------------


]